export default [
  {
    header: 'Service status',
    title: 'Service status',
    name: 'service-status',
    href: 'https://status.soustitreur.com',
    icon: 'InfoIcon',
  },
  
]